import { flushSync } from "react-dom";

// React Router v7's declarative <BrowserRouter>/<Routes> mode does NOT
// support the `viewTransition` prop on Link/navigate (confirmed by testing
// against this app directly — it's only wired up for the data/framework
// routers, createBrowserRouter/RouterProvider). This is the manual
// equivalent for plain declarative mode: document.startViewTransition
// needs the DOM mutated *synchronously* inside its callback to capture the
// correct before/after snapshots — flushSync forces React's state update
// (and the resulting re-render) to happen synchronously right there,
// instead of deferring it.
export function withViewTransition(domUpdateCallback) {
  if (!document.startViewTransition) {
    domUpdateCallback();
    return;
  }
  document.startViewTransition(() => flushSync(domUpdateCallback));
}
